import styled, { keyframes } from 'styled-components';

export const BogoMainContainer = styled.div``;

export const ClothDiaperGrid = styled.div`
  display: grid;
  grid-template-columns: 480px 1fr;

  @media (max-width: 720px) {
    grid-template-columns: 100%;
  }
`;

export const Cross = styled.span`
  position: absolute;
  top: -48px;
  right: 10px;
  cursor: pointer;
  z-index: 99;
  color: #fff;
  font-size: 44px;
  font-weight: 400;

  @media (max-width: 720px) {
    top: -4px;
    right: 10px;
    cursor: default;
    z-index: 99;
    color: #000000ba;
    font-size: 37px;
  }
`;

export const RightSection = styled.div`
  position: relative;
  padding-right: 6px;

  @media (max-width: 720px) {
    padding-right: 0;
  }
`;

export const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 47%);
  justify-content: space-between;
  padding: 40px 14px 95px;
  height: 475px;
  overflow-y: auto;
  position: relative;

  @media (max-width: 720px) {
    height: ${(props) => props.heightChange};
    display: flex;
    column-gap: 10px;
    background-color: #f9f9f9;
    overflow-y: hidden;
    padding: 2px 14px 95px;
  }

  &::-webkit-scrollbar {
    width: 5px;
    transition: all 0.3s ease;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #fff;
  }
  &::-webkit-scrollbar-track {
    background-color: #fff;
  }

  &:hover {
    &::-webkit-scrollbar {
      width: 5px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #c1c1c1;
    }
  }
`;

export const Card = styled.div`
  border-radius: 4px;
  box-shadow: 0 3px 6px 0 rgb(0 0 0 / 16%);
  background-color: #fff;
  height: max-content;
  padding-bottom: 6px;
  margin: 14px 0;

  &.selected {
    border: 1px solid hsl(0deg, 0%, 0%, 80%);
  }

  @media (max-width: 720px) {
    flex-shrink: 0;
    flex-basis: 38%;
  }

  img {
    width: 100%;
    height: auto;
    border-radius: 4px 4px 0 0;
    aspect-ratio: 16/16;

    @media (max-width: 720px) {
      height: 132px;
    }
  }
`;

export const VariantName = styled.h5`
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 80%);
  padding: 4px 0 5px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin: auto;
  width: calc(100% - 8px);
`;

export const VariantDetail = styled.div`
  padding: 0 6px;
`;

const stripFade = keyframes`
    from{
        opacity: 0;
    }
    to{
        opacity: 1;
    }
`;

export const DesktopDiaperStrip = styled.div`
  border-radius: 0 8px 0 0;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #fff;
  position: absolute;
  top: 0;
  z-index: 9;
  width: 100%;
  height: 50px;
  line-height: 50px;
  font-weight: 600;
  color: hsl(0deg, 0%, 0%, 87%);
  font-size: 14px;

  p {
    width: calc(100% - 30px);
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    margin: auto;

    &.fadeInEffect {
      opacity: 1;
      animation: ${stripFade} 2.4s linear;
    }
  }

  @media (max-width: 720px) {
    display: none;
  }
`;

export const MobileTopStrip = styled.h4`
  display: none;

  @media (max-width: 720px) {
    display: block;
    background: #f9f9f9;
    text-align: left;
    padding: 10px 16px 10px;
    font-size: 14px;
    color: rgb(0 0 0 / 80%);
  }

  span {
    text-overflow: ellipsis;
    width: calc(100% - 10px);
    margin: auto;
    white-space: nowrap;
    overflow: hidden;
    display: inline-block;

    &.fadeInEffect {
      opacity: 1;
      animation: ${stripFade} 2.4s linear;
    }
  }
`;

export const ProceedButton = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  background-color: #fff;
  box-shadow: 0 -2px 6px 0 rgba(0, 0, 0, 0.16);
  width: 100%;
  max-width: 420px;
  padding: 8px 14px;
  z-index: 999;
`;

export const OfferStrip = styled.div`
  position: absolute;
  bottom: 60px;
  width: 100%;
  background: ${(props) => props.bg};
  left: 0;
  padding: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  color: hsl(0deg, 0%, 0%, 60%);
  letter-spacing: 0.16px;
  font-weight: 600;
  box-shadow: 0 -3px 6px 0 rgba(0, 0, 0, 0.16);

  img {
    width: 16px;
    height: auto;
    margin-right: 8px;
  }
`;

export const AddDeleteItem = styled.div`
  width: 120px;
  height: 34px;
  background-color: hsl(0deg, 0%, 0%, 4%);
  display: flex;
  align-items: center;
  margin: auto;

  @media (max-width: 720px) {
    height: 30px;
  }

  .disabled {
    opacity: 0.3;
  }

  .common_button {
    height: 34px;
    flex-grow: 1;
    flex-basis: 33.33%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;

    @media (max-width: 720px) {
      height: 30px;
    }
  }
  .total_items {
    background: #fff;
    border: 0.5px solid rgb(0 0 0 / 46%);
    font-size: 14px;
    font-weight: 500;
    color: hsl(0deg 0% 0% / 87%);
  }

  .plusMinusImage {
    width: 26px;
    height: auto;
  }

  .plus_items,
  .delete_items {
    position: relative;
    @media (min-width: 720px) {
      cursor: pointer;
    }
    &:hover {
      background-color: #dfdfdf80;
      @media (max-width: 720px) {
        background-color: transparent;
      }
    }
  }
`;
export const AnimatedGif = styled.img`
  position: absolute;
  bottom: 0;
  width: 80%;
  z-index: 999;
  left: 50%;
  transform: translate(-50%, 0);
`;

export const BogoLabel = styled.span`
  background-color: #63b0a8;
  color: #fff;
  font-weight: 600;
  display: inline-block;
  border-radius: 0 3px 3px 0;
  border-left: 3px solid #3a9189;
  margin-right: 10px;
  padding: 2px 6px;
`;
